<template>
    <!-- <div class="listItems" v-if="questionList" @click.prevent="reportDetail(questionList.id)">
          <div class="d-flex align-items-center justify-content-between pdt-17 pdl-16 pdr-16 pdb-8">
              <div class="t-body4 t-color-bodyGrayA font-13">{{$moment(questionList.requestDate).format('YYYY. MM. DD')}}</div>
              <div class="t-body4 t-color-blue  font-13" v-if="questionList && questionList.response===true">{{ $t('1287') }}</div>
              <div class="t-body4 t-color-lectureRed  font-13" v-if="questionList && questionList.response===false">{{ $t('1955') }}</div>
          </div>
          <div class="l-spacing48 tbody1 t-color-headlineBlack pdl-16 pdr-16 pdb-16 font-r " v-if="questionList && questionList.contents.length<45">{{questionList.contents}}</div>
          <div class="l-spacing48 tbody1 t-color-headlineBlack pdl-16 pdr-16 pdb-16 font-r " v-else>{{questionList && questionList.contents ? questionList.contents.substring(0,43)+"...":''}}</div>
    </div> -->
                <div class="mdc-card__primary-action pdt-24 pdb-24 pdl-24 pdr-24" v-if="questionList" @click.prevent="reportDetail(questionList.id)" @keypress.prevent="reportDetail(questionList.id)" tabindex="0">
                <div class="d-flex justify-content-between align-items-center t-line-h-18">
                    <div class="t-body3 t-color-bodyGrayA font-rn">{{$moment(questionList.requestDate).format('L')}}</div>
                    <div class="t-body3 t-color-red font-r" v-if="questionList && questionList.response===false">{{ $t('1955') }}</div>
                    <div class="t-body3 t-color-signBlue font-r" v-if="questionList && questionList.response===true">{{ $t('1287') }}</div>
                </div>
                <div class="d-flex">
                    <div class="flex-grow-1">
                        <div class="t-body1 font-r l-spacing48 mgt-16 t-line-h-26 t-line-2" >{{questionList.contents}}
                        </div>
                        
                    </div>
                </div>
            </div>
    
</template>

<script>
/**
 * 나의 학습 목록 아이템 컴포넌트(my learning main list item component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import learnApi from "@/api/learnApi.js";

export default {
  props: ["questionList"],
  data() {
    return {
      learnProgressRate: {},
    };
  },

  mounted() {},

  computed: {},
  methods: {
    reportDetail(id) {
      let issueId = id;
      this.$router.push({
          name: 'ReportDetail', 
          params: {issueId:issueId}
      })
    }
  },
};
</script>

<style scoped>
.nav-extended .brand-logo, .nav-content * {
      font-family: noto-regular;
    }
    .nav-extended .brand-logo{
      font-size:20px;
    }
  .tabs .tab a:focus, .tabs .tab a:focus.active {
      background-color: #F5F5F5;
      outline: none;
  }
  .tabs .indicator{
    background:#2d6dcc;
  }
  .mdc-elevation--z3 {
      border-radius: 4px;

      box-shadow: 0 1px 3px 0 var(--Shadow1);
    background-color: var(--DocumentWhite);
  }
  .tabs .tab {
    width: 50%;
    }
  
  .font-13{
    font-size:13px !important;
  }
  .t-color-blue{
    color: #2d6dcc !important
  }
  
</style>